export const APPLICANT_DRAFT_CREATE_ACTION_FIELD_NAME = 'action'

export const QA_NAME_APPLICANT_DRAFT_LISTING = 'applicantDraftListing'

export const QA_NAME_APPLICANT_DRAFT_SAVED_AT = 'applicantDraftSavedAt'
